import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, flatMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { SearchResultUiService } from '../../pages/search-result/services/search-result-ui.service';
import { SearchResponse } from '@core/models/domains/hotel';
import { API_IHO_URL } from '../../app.module';

@Injectable()
export class MetaScriptInterceptor implements HttpInterceptor {
  router = inject(Router);
  isShab: boolean = false;
  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(API_IHO_URL) private baseUrl?: string
  ) {

  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // فقط اگر درخواست به API مشخصی است
    if (
      req.url.includes('search/filter') ||
      req.url.includes('accomodation/filter') ||
      req.url.includes('hotelInfo/getHotelSummaryInfo') ||
      req.url.includes('accomodation/getHotelSummaryInfo') ||
      req.url.includes('home/GetAllSections') ||
      req.url.includes('accomodation/GetAllSections') ||
      req.url.includes('dynamicSearchFilter')
    ) {
      return next.handle(req).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.handleResponse(event);
            this.createCanonical(req.url, next, req, event);
            if (
              req.url.includes('/search/filter?') && // only for plp page (Search Result)
              isPlatformServer(this.platformId) // we need it just for first render
            ) {
              const paramsArray = this.document.location.search.split('&') ?? '';
              this.createNextAndPrevLinks(paramsArray, paramsArray?.length > 1, event.body);
            } else if (isPlatformBrowser(this.platformId)) {
              this.hidePaginationButtons();
            }
          }
        })
      );
    }

    return next.handle(req);
  }

  private handleResponse(event: HttpResponse<any>) {

    if (event.body.Type == 2) {
      this.isShab = true;
    }
    if (event.body.JsonBreadcrumb) {
      this.addScripts(event.body.JsonBreadcrumb);
    }
    if (event.body.JsonFaq) {
      this.addScripts(event.body.JsonFaq);
    }
    if (event.body.JsonInfo) {
      this.addScripts(event.body.JsonInfo);
    }
    if (event.body.JsonInfoItems) {
      this.addScripts(event.body.JsonInfoItems);
    }
    if (event.body.MetaTags) {

      this.addMetaTags(event.body.MetaTags, event.url);
    }

  }

  private addMetaTags(
    metaTags: { Keywords: string; PageDescription: string; Title: string },
    url: any
  ) {
    for (const meta in metaTags) {
      if (Object.prototype.hasOwnProperty.call(metaTags, meta)) {
        const itemValue = (metaTags as any)[meta];
        switch (meta) {
    
          case 'PageDescription': {
            this.createOrGetMetaElement('name', 'description', itemValue);
            this.createOrGetMetaElement('property', 'og:description', itemValue);
            this.createOrGetMetaElement('name', 'twitter:description', itemValue);
            break;
          }

          case 'Title': {
            this.createOrGetMetaElement('property', 'og:title', itemValue);
            this.createOrGetMetaElement('name', 'twitter:title', itemValue);
            // ---
            let titleEl = this.document.querySelector('title');

            if (!titleEl) titleEl = this.document.createElement('title');

            titleEl.textContent = itemValue;

            this.document.head.appendChild(titleEl);
            break;
          }

          default:
            break;
        }
      }
    }


  }

  private createOrGetMetaElement(attributeKey: string, attributeValue: string, content: string) {
    let metaEl = this.document.querySelector(`meta[${attributeKey}="${attributeValue}"]`);
    if (!metaEl) metaEl = this.document.createElement('meta');

    metaEl.setAttribute(attributeKey, attributeValue);
    metaEl.setAttribute('content', content);
    this.document.head.insertBefore(metaEl, this.document.head.firstElementChild);
    //this.document.head.appendChild(metaEl)
  }

  private addScripts(script: string) {
    // اضافه کردن اسکریپتها
    const scriptEl = this.document.createElement('script');
    scriptEl.type = 'application/ld+json';
    const scriptWithoutTag = script
      .replace("<script type='application/ld+json'>", '')
      .replace('</script>', '');

    scriptEl.text = scriptWithoutTag;
    this.document.body.appendChild(scriptEl);
  }
  setCanonical(flag: boolean) {
    let queryParams = this.route.snapshot.queryParams;

    let metaEl = this.document.querySelector(`meta[name="robots"]`);
    if (!metaEl) metaEl = this.document.createElement('meta');

    let linkCanonical = this.document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) linkCanonical = this.document.createElement('link');
    linkCanonical.setAttribute('rel', 'canonical');

    if (this.document.location.search != '') {
      metaEl.setAttribute('name', 'robots');
      // TODO what is this ?
      if (
        !flag &&
        (queryParams?.['page'] || queryParams['page']?.includes('-') || queryParams?.['date'])
      ) {

        metaEl.setAttribute(
          'content',
          'nofollow, noindex, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        );
      } else {
        if(!this.isShab){
        metaEl.setAttribute(
          'content',
          'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        );
        }
        else{
          metaEl.setAttribute(
            'content',
            'nofollow, noindex, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
          );
        }
      }
    } else {
      if (!this.isShab) {
      metaEl.setAttribute('name', 'robots');
      metaEl.setAttribute(
        'content',
        'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
      );
      }
      else {
        metaEl.setAttribute('name', 'robots');
        metaEl.setAttribute(
          'content',
          'nofollow, noindex, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        );
      }
    }

    // linkCanonical.setAttribute('href',this.document.location.origin +  this.router.url.split('?')[0]);
    if (this.document.location.pathname.includes('/home')) {
      linkCanonical.setAttribute('href', 'https://www.iranhotelonline.com');
    } else {
      if (flag)
        linkCanonical.setAttribute(
          'href',
          'https://www.iranhotelonline.com' +
          decodeURIComponent(this.document.location.pathname).toLocaleLowerCase() +
          '?page=' +
          queryParams['page']
        );
      else
        linkCanonical.setAttribute(
          'href',
          'https://www.iranhotelonline.com' +
          decodeURIComponent(this.document.location.pathname).toLocaleLowerCase()
        );
    }

    // this.document.head.appendChild(linkCanonical)
    // this.document.head.appendChild(metaEl)
    this.document.head.insertBefore(metaEl, this.document.head.firstElementChild);
    this.document.head.insertBefore(linkCanonical, this.document.head.firstElementChild);
  }


  private createCanonical(url: any, next: HttpHandler, req: any, event: HttpEvent<any>) {
    let pageIndex = this.route.snapshot.queryParams;
    let flag = false;
    // check response plp cards is exist
    if (url.includes('/search/filter?') || url.includes('/search/dynamicSearchFilter?')) {
      // next.handle(req)
      //   .subscribe({
      //     next: (event: any) => {
      if (event instanceof HttpResponse) {
        let response = event.body;
        if (!response.Cards?.length) {
          flag = false;
        }
        if (response.Error) {
          flag = false;
        }
        if (response.Cards?.length) {
          if (
            pageIndex?.['page'] &&
            pageIndex['page'] != '1' &&
            pageIndex['page'] != '0' &&
            !pageIndex['page'].includes('-')
          ) {
            flag = true;
          } else {
            flag = false;
          }
        }

        this.setCanonical(flag);
      }
    } else {
      this.setCanonical(false);
    }
  }

  createNextAndPrevLinks(params: string[], hasQueryParams: boolean, response: SearchResponse) {
    const foundedPage = params
      .filter((each) => each.split('=')[0] === 'page' || each.split('=')[0] === '?page')
      .join('');
    const currentPageNumber = foundedPage.split('=')?.[1]
      ? Number(foundedPage.split('=')[1])
      : undefined;
    const foundIndex = params.indexOf(foundedPage);
    const isLastPage = Math.ceil(response?.PageTitle?.CountHotel / Number(currentPageNumber)) <= 10; //10 is our pageSize
    if (response?.Cards.length <= 10 && !isLastPage) return;
    let nextPageUrl = '';
    let prevPageUrl = '';
    if (currentPageNumber && currentPageNumber > 1 && foundIndex !== -1) {
      params.splice(foundIndex, 1); // now we have all params but page
      const queryParamsWithoutPage = params.join('&');
      const prevPageLink = this.document.createElement('link');
      nextPageUrl =
        'https://www.iranhotelonline.com' +
        this.document.location.pathname +
        queryParamsWithoutPage +
        (hasQueryParams ? '&' : '?') +
        `page=${currentPageNumber + 1}`;
      prevPageUrl =
        'https://www.iranhotelonline.com' +
        this.document.location.pathname +
        queryParamsWithoutPage +
        (currentPageNumber === 2 ? '' : (hasQueryParams ? '&' : '?') + `page=${currentPageNumber - 1}`);

      if (!isLastPage) {
        const nextPageLink = this.document.createElement('link');
        nextPageLink.setAttribute('rel', 'next');
        nextPageLink.setAttribute('href', nextPageUrl);
        this.document.head.appendChild(nextPageLink);
      }

      prevPageLink.setAttribute('rel', 'prev');
      prevPageLink.setAttribute('href', prevPageUrl);
      this.document.head.appendChild(prevPageLink);
    } else {
      //----------- is first page
      const nextPageLink = this.document.createElement('link');
      nextPageUrl =
        'https://www.iranhotelonline.com' +
        this.document.location.pathname +
        (hasQueryParams ? this.document.location.search + '&page=2' : '?page=2');
      nextPageLink.setAttribute('rel', 'next');
      nextPageLink.setAttribute('href', nextPageUrl);
      this.document.head.appendChild(nextPageLink);
    }
    this.createPaginationButtonsForJsDisabled(nextPageUrl, prevPageUrl);
  }

  createPaginationButtonsForJsDisabled(nextPageLink: string, prevPageLink: string) {
    
    const contentWrapper = this.document.querySelector('#cardsWrapper');
    if (!contentWrapper) return;

    const classes =
      'px-4 py-2 text-base text-white bg-blue-600 flex items-center justify-center seo-friendly-pagination-buttons';
    const nextBtnElement = this.document.createElement('a');
    const prevBtnElement = this.document.createElement('a');

    prevBtnElement.setAttribute('target', '_blank');
    if (prevPageLink) {
      prevBtnElement.setAttribute('href', prevPageLink);
      nextBtnElement.style.position = 'absolute';
      nextBtnElement.style.clip = 'rect(0,0,0,0)';
      nextBtnElement.style.pointerEvents = 'none';
      prevBtnElement.textContent = 'صفحه قبلی';
    }
    // prevBtnElement.classList.add(classes)

    nextBtnElement.setAttribute('target', '_blank');
    if (nextPageLink) {
      nextBtnElement.setAttribute('href', nextPageLink);
      nextBtnElement.style.position = 'absolute';
      nextBtnElement.style.clip = 'rect(0,0,0,0)';
      nextBtnElement.style.pointerEvents = 'none';
      nextBtnElement.textContent = 'صفحه بعدی';
    }
    // nextBtnElement.classList.add(classes)

    if (!nextPageLink) {
      // is last page
      nextBtnElement.setAttribute('disabled', 'true');
    } else if (!prevPageLink) {
      // is first page
      prevBtnElement.setAttribute('disabled', 'true');
    }

    this.document.body.appendChild(prevBtnElement);
    this.document.body.appendChild(nextBtnElement);
  }

  hidePaginationButtons() {
    const buttons = this.document.querySelectorAll('.seo-friendly-pagination-buttons');
    if (!buttons) return;

    buttons.forEach((el: Element, key: number, _: any) => {
      el.classList.add('!hidden');
    });
  }
}
